import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { BackupJobResponse } from '../models/BackupJobResponse';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest';

/**
 * no description
 */
export class ConvertOtherSnapshotsOnDemandApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Convert other snapshots to eon snapshots on demand
   * @param projectId The project ID
   * @param id ID of the inventory item
   * @param convertOtherSnapshotsOnDemandRequest The request body for creating a new backup job
   */
  public async convertOtherSnapshotsOnDemand(projectId: string, id: string, convertOtherSnapshotsOnDemandRequest: ConvertOtherSnapshotsOnDemandRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ConvertOtherSnapshotsOnDemandApi", "convertOtherSnapshotsOnDemand", "projectId");
    }


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("ConvertOtherSnapshotsOnDemandApi", "convertOtherSnapshotsOnDemand", "id");
    }


    // verify required parameter 'convertOtherSnapshotsOnDemandRequest' is not null or undefined
    if (convertOtherSnapshotsOnDemandRequest === null || convertOtherSnapshotsOnDemandRequest === undefined) {
      throw new RequiredError("ConvertOtherSnapshotsOnDemandApi", "convertOtherSnapshotsOnDemand", "convertOtherSnapshotsOnDemandRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/inventory/{id}/convert-other-snapshots-on-demand'
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(convertOtherSnapshotsOnDemandRequest, "ConvertOtherSnapshotsOnDemandRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ConvertOtherSnapshotsOnDemandApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to convertOtherSnapshotsOnDemand
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async convertOtherSnapshotsOnDemandWithHttpInfo(response: ResponseContext): Promise<HttpInfo<BackupJobResponse >> {
    if (isCodeInRange("201", response.httpStatusCode)) {
      const body: BackupJobResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "BackupJobResponse", ""
      ) as BackupJobResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: BackupJobResponse = await response.body.json() as BackupJobResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
